import type { ForumBase } from '../types/forum';
import { getForumGrowthPercent } from './forumGrowth';

/** Türkiye Forum Endeksi (TFE): aktif forumların ağırlıklı büyüme ortalaması */
export function computeTurkeyForumIndex(forums: ForumBase[]): {
  index: number;
  activeCount: number;
  avgMemberGrowth: number | null;
  totalMembers: number;
  monthLabel: string;
} {
  const active = forums.filter((f) => f.is_active !== false);
  const growths = active
    .map((f) => getForumGrowthPercent(f, 'members'))
    .filter((g): g is number => g !== null);
  const avgGrowth =
    growths.length > 0 ? growths.reduce((a, b) => a + b, 0) / growths.length : null;
  const base = 100;
  const index = avgGrowth !== null ? Math.round(base + avgGrowth * 10) / 10 : base;
  const totalMembers = active.reduce((s, f) => s + (f.members_count || 0), 0);
  const monthLabel = new Date().toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' });
  return {
    index,
    activeCount: active.length,
    avgMemberGrowth: avgGrowth !== null ? Math.round(avgGrowth * 100) / 100 : null,
    totalMembers,
    monthLabel,
  };
}
